<template>
  <div class="self-developed-products py-80px">
    <div class="block-content">
      <block-title :en="products.title.en" :title="products.title.value" :sub="products.title.sub"></block-title>

      <div class="prod-tabs mt-80px">
        <div class="prod-tab" :class="{ active: currentIndex === index }" v-for="(item, index) in products.tabs" :key="item.name" @click="currentIndex = index">
          {{ item.name }}
        </div>
      </div>

      <div class="prod-list mt-60px">
        <div class="prod-item" v-for="item in currentProducts" :key="item.name">
          <div class="prod-img-wrap">
            <img class="prod-img" :src="item.img" alt="" />
          </div>
          <div class="prod-name">{{ item.name }}</div>
          <div class="prod-desc">{{ item.description }}</div>
        </div>
      </div>

      <div class="prod-button" @click="navMore">
        查看更多
        <img src="@/asset/index/ic_index_50.png" class="icon" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    ...mapGetters(['globalData']),
    products() {
      return this.globalData['airport-vehicle-management'].selfDevelopedProducts;
    },
    currentProducts() {
      const currentTab = this.products.tabs[this.currentIndex] || {};
      return currentTab.list || [];
    }
  },
  methods: {
    navMore() {
      this.$router.push('/productCenter');
    }
  }
};
</script>

<style lang="scss" scoped>
.self-developed-products {
  background: url('@/asset/index/csb_index_30.png') no-repeat center/cover;
  * {
    box-sizing: border-box;
  }
  .prod-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
  .prod-tab {
    min-width: 190px;
    height: 56px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 28px;
    border: 1px solid rgba(9, 109, 217, 0.24);
    background: #ffffff;
    color: #666666;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.3s;
    &:hover,
    &.active {
      color: #ffffff;
      background: linear-gradient(180deg, #4e99fd 0%, #3384e8 100%);
      box-shadow: 0 8px 20px rgba(9, 109, 217, 0.18);
    }
  }
  .prod-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }
  .prod-item {
    min-height: 420px;
    padding: 20px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 5px 8px 20px 0 #dadada;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-8px);
    }
  }
  .prod-img-wrap {
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7fbff;
    border-radius: 8px;
    overflow: hidden;
  }
  .prod-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .prod-name {
    margin-top: 24px;
    color: #282938;
    font-size: 22px;
    font-weight: 600;
    line-height: 32px;
  }
  .prod-desc {
    margin-top: 12px;
    color: #666666;
    font-size: 16px;
    line-height: 28px;
  }
  .prod-button {
    width: 217px;
    padding: 20px 0;
    margin: 48px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: #fffdfd;
    font-size: 24px;
    background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
    border-radius: 2px;
    cursor: pointer;
    .icon {
      width: 30px;
    }
  }
}
</style>
